import { StarIcon } from "@heroicons/react/24/solid";
import { useTailwindBreakpoints } from "lib/hooks/useTailwindBreakpoints";
import Image from "next/image";
import React from "react";

const Testimonial = ({
  name,
  testimonial,
  designation,
  avtar,
}: {
  name: string;
  testimonial: string;
  designation: string;
  avtar: string;
}) => {
  const { isMd } = useTailwindBreakpoints();
  const avtarDimension = isMd ? 40 : 24;
  return (
    <div className="w-[300px] space-y-3 rounded-2xl bg-white p-3 font-montserrat drop-shadow-md md:h-[188px] md:w-[504px] md:p-4">
      <div className="flex space-x-1">
        <StarIcon className="h-3 w-3 text-yellow-500 md:h-5 md:w-5" />
        <StarIcon className="h-3 w-3 text-yellow-500 md:h-5 md:w-5" />
        <StarIcon className="h-3 w-3 text-yellow-500 md:h-5 md:w-5" />
        <StarIcon className="h-3 w-3 text-yellow-500 md:h-5 md:w-5" />
        <StarIcon className="h-3 w-3 text-yellow-500 md:h-5 md:w-5" />
      </div>
      <p className="text-xs text-[#6B6B78] md:text-base">{testimonial}</p>
      <div className="flex items-center gap-2">
        <Image
          src="/assets/sampleUserAvtar.png"
          width={avtarDimension}
          height={avtarDimension}
          alt="Testimonial User Avtar"
        />
        <div className="text-xs font-bold text-[#2E2E2E] md:text-base">
          {name}
        </div>
        {/* <div className="ml-auto text-[#6B6B78]">Designer</div> */}
      </div>
    </div>
  );
};

export default Testimonial;
